<template>
    <div>
        <!-- Low response state -->
        <div v-if="isLowResponseCount" class="feedback-container">
            <div class="feedback-summary-row">
                <div class="feedback-summary">
                    <strong>Not Enough Responses:</strong> There were not enough responses to
                    generate a summary. Click "Feedback" to see all responses from this group.
                </div>

                <button class="feedback-history-icon-button" @click="$emit('openFeedback')">
                    <BaseIcon class="icon" icon="comment" color="#056DC7" />
                    Feedback
                </button>
            </div>
        </div>

        <!-- Normal themes -->
        <div v-else>
            <div
                v-for="([categoryName, report], index) in Object.entries(studentFeedback)"
                :key="categoryName"
                class="feedback-container"
            >
                <div class="feedback-summary-row">
                    <div class="feedback-summary">
                        <b> {{ categoryName }} </b>:&nbsp;<span>{{ report.summary }}</span>
                    </div>

                    <button
                        class="feedback-history-icon-button"
                        @click="$emit('openSamples', categoryName, report)"
                    >
                        <BaseIcon class="icon" icon="comment" color="#056DC7" />
                        Samples
                    </button>
                </div>

                <BaseDivider v-if="index < studentFeedbackSize" />
            </div>
        </div>
    </div>
</template>

<script setup>
import { BaseDivider, BaseIcon } from '@edsights/ui-core';
import { computed } from 'vue';

// Props
const props = defineProps({
    studentFeedback: {
        type: Object,
        required: true
    },
    isLowResponseCount: {
        type: Boolean,
        default: false
    }
});

// Emits
defineEmits(['openSamples', 'openFeedback']);

// Computed
const studentFeedbackSize = computed(() => {
    return Object.keys(props.studentFeedback).length - 1;
});
</script>

<style scoped lang="scss">
@import '~@/styles/variables';

.feedback-summary {
    width: 85%;
}

.feedback-container {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.feedback-summary-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    padding: 1rem 0;
}

.feedback-history-icon-button {
    align-items: center;
    background-color: rgba($primary-dark, 0.1);
    border-radius: 0.25rem;
    border: none;
    color: $primary-dark;
    cursor: pointer;
    display: flex;
    font-size: 0.9rem;
    font-weight: bold;
    gap: 0.25rem;
    justify-content: center;
    padding: 0.25rem 0.5rem;
}
</style>
